import { render } from "./ManageHealth.vue?vue&type=template&id=6c348405&scoped=true"
import script from "./ManageHealth.vue?vue&type=script&lang=js"
export * from "./ManageHealth.vue?vue&type=script&lang=js"

import "./ManageHealth.vue?vue&type=style&index=0&id=6c348405&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c348405"]])

export default __exports__